export default __webpack_public_path__ + "static/media/021-forbidden city.14b3695c.svg";